import { render, staticRenderFns } from "./pl5.vue?vue&type=template&id=343a075d"
import script from "./pl5.vue?vue&type=script&lang=js"
export * from "./pl5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports